  const PDPMediaPopupSwiper = new Swiper("[data-media-popup-swiper]", {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: false,
    navigation: {
      nextEl: "[data-pdp-media-popup] .swiper-button-next",
      prevEl: "[data-pdp-media-popup] .swiper-button-prev",
    },
    on: {
      slideChange() {
        if (this.el) updatePopupNavState(this.el);
      },
    },
  });

  let pendingPopupMediaId = null;

  function syncPopupToMediaId(mediaId) {
    const swiperEl = document.querySelector("[data-media-popup-swiper]");
    if (!swiperEl?.swiper || !mediaId) return;
    const swiper = swiperEl.swiper;
    const allSlides = Array.from(swiperEl.querySelectorAll(".swiper-slide"));
    let targetSlide = allSlides.find((s) => s.getAttribute("data-media-id") === mediaId);
    if (!targetSlide && mediaId.includes("-")) {
      const mediaIdPart = mediaId.split("-").pop();
      targetSlide = allSlides.find((s) => {
        const sid = s.getAttribute("data-media-id");
        return sid && (sid === mediaId || sid.endsWith("-" + mediaIdPart));
      });
    }
    if (!targetSlide) return;
    const wrapper = swiperEl.querySelector(".swiper-wrapper");
    if (!wrapper) return;

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        const slides = Array.from(wrapper.querySelectorAll(".swiper-slide"));
        const visibleSlides = slides.filter(
          (s) => !s.classList.contains("product__popup-slide--hidden-alt")
        );
        const hasFiltered = visibleSlides.length < slides.length;

        if (hasFiltered && visibleSlides.length > 0) {
          const hiddenSlides = slides.filter((s) =>
            s.classList.contains("product__popup-slide--hidden-alt")
          );
          visibleSlides.forEach((s) => wrapper.appendChild(s));
          hiddenSlides.forEach((s) => wrapper.appendChild(s));
          swiperEl.dataset.visibleSlideCount = String(visibleSlides.length);
        } else {
          delete swiperEl.dataset.visibleSlideCount;
        }

        swiper.update();
        const listToUse = hasFiltered ? visibleSlides : slides;
        let slideIndex = listToUse.indexOf(targetSlide);
        if (slideIndex < 0) {
          slideIndex = listToUse.findIndex(
            (s) => s.getAttribute("data-media-id") === mediaId
          );
        }
        if (slideIndex >= 0) {
          swiper.slideTo(slideIndex, 0);
        }
        updatePopupNavState(swiperEl);
      });
    });
  }

  function updatePopupNavState(swiperEl) {
    const swiper = swiperEl?.swiper;
    if (!swiper) return;
    const visibleCount = swiperEl.dataset.visibleSlideCount;
    const nextBtn = swiperEl.closest("[data-pdp-media-popup]")?.querySelector(".swiper-button-next");
    const prevBtn = swiperEl.closest("[data-pdp-media-popup]")?.querySelector(".swiper-button-prev");
    if (!visibleCount) {
      if (nextBtn) {
        nextBtn.style.pointerEvents = "";
        nextBtn.classList.remove("swiper-button-disabled");
      }
      if (prevBtn) {
        prevBtn.style.pointerEvents = "";
        prevBtn.classList.remove("swiper-button-disabled");
      }
      return;
    }
    const n = parseInt(visibleCount, 10);
    const i = swiper.activeIndex;
    if (nextBtn) {
      const atLastVisible = i >= n - 1;
      nextBtn.style.pointerEvents = atLastVisible ? "none" : "";
      nextBtn.classList.toggle("swiper-button-disabled", atLastVisible);
      nextBtn.setAttribute("aria-disabled", atLastVisible ? "true" : "false");
    }
    if (prevBtn) {
      const atFirst = i <= 0;
      prevBtn.style.pointerEvents = atFirst ? "none" : "";
      prevBtn.classList.toggle("swiper-button-disabled", atFirst);
      prevBtn.setAttribute("aria-disabled", atFirst ? "true" : "false");
    }
  }

  document.addEventListener("click", (e) => {
    const listItem = e.target.closest(".product__media-item[data-media-id]");
    if (!listItem || !listItem.closest("media-gallery")) return;
    pendingPopupMediaId = listItem.getAttribute("data-media-id");
  }, true);

  const popupObserver = new MutationObserver(() => {
    if (!document.body.classList.contains("show__media-popup")) return;
    if (pendingPopupMediaId == null) return;
    const mediaId = pendingPopupMediaId;
    pendingPopupMediaId = null;
    requestAnimationFrame(() => {
      syncPopupToMediaId(mediaId);
    });
  });
  popupObserver.observe(document.body, { attributes: true, attributeFilter: ["class"] });